import React, { useEffect, useState, useContext } from 'react';

import I18NextContext from '../../../../i18next-context/I18NextContext';
import { formatPriceString } from '../../extended-product-modal/util/ProductModalHelpers';
import './CuratedCard.css';


const CuratedCard = ({ productInfo, setProductFromRelated, fragranceColorRemove }) => {
    const { currentLanguage } = useContext(I18NextContext);

    return (
        <div className='stl-curated-card' onClick={() => setProductFromRelated(productInfo.sku, productInfo.name)}>
            <img src={productInfo?.carousel_images?.carousel?.[0]?.path} className="stl-curated-img" />
            <div className="curated-text">
                {fragranceColorRemove.includes(productInfo.sku) ? productInfo.name.replace('Incolore', '').replace('Incoloro', '') : productInfo.name}
                <span className='curated-price'>{formatPriceString(productInfo.price, currentLanguage)}</span>
            </div>
        </div>
    )
}

export default CuratedCard;